import React from 'react';
import { useProducts } from '../../Context/ProductProvider';
import NewArrival from '../Home/NewArrival';
import SliderProduct from '../Home/SliderProduct';
import Loading from '../Loading/Loading';
import { useState } from 'react';


const Products = () => {
    const { state: { products, loading, error } } = useProducts();

    const [minPrice, setMinPrice] = useState(-Infinity);
    const [maxPrice, setMaxPrice] = useState(Infinity);

    const handlePriceChange = (e, isMin) => {
        const value = parseInt(e.target.value);
        if (isMin) {
            setMinPrice(isNaN(value) ? -Infinity : value);
        } else {
            setMaxPrice(isNaN(value) ? Infinity : value);
        }
    };

    const filteredProducts = products.filter(
        (product) => product.price >= minPrice && product.price <= maxPrice
    );

    let content;

    if (loading) {
        content = <Loading></Loading>
    }
    if (error) {
        content = <h1>Something went wrong</h1>
    }

    if (!loading && !error && filteredProducts.length === 0) {
        content = <p className='text-lg text-red-500'>No products match your price</p>
    }

    if (!loading && !error && filteredProducts.length) {
        content = filteredProducts.map((product) => (
            <SliderProduct product={product} key={product.id}></SliderProduct>
        ))
    }
    return (
        <div>
            {/* <div className="container py-24 overflow-hidden">
                <div className='flex justify-between items-baseline'>
                    <h2 className="text-2xl font-medium text-gray-800 uppercase mb-6">all products</h2>
                  
                </div>
            
                <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-6">
                  
                    {content}
                </div>
        
                <NewArrival></NewArrival>
           

            </div> */}
            <div class="container grid lg:grid-cols-4 sm:gird-cols-3 w-full gap-6 pt-4 pb-16 items-start">

                {/* sidebar  */}
                <div
                    class="col-span-3 lg:col-span-1 bg-white px-4 pt-4 pb-6 shadow rounded overflow-hidden lg:static left-4 top-16 z-10 w-full lg:block">
                    <div class="divide-gray-200 divide-y space-y-5">
                        <div class="pt-4">
                            <h3 class="text-xl text-gray-800 mb-3 uppercase font-medium">Price</h3>
                            <div class="mt-4 flex items-center">
                                <input type="text"
                                    class="w-full border-2 focus:ring-0 focus:border-primary px-3 py-1 text-gray-600 text-sm shadow-sm rounded"
                                    placeholder="min" onChange={(e) => handlePriceChange(e, true)} />
                                <span class="mx-3 text-gray-500">-</span>
                                <input type="text"
                                    class="w-full border-2 focus:ring-0 focus:border-primary px-3 py-1 text-gray-600 text-sm shadow-sm rounded"
                                    placeholder="max" onChange={(e) => handlePriceChange(e, false)} />
                            </div>
                        </div>
                        {/* price filter end  */}
                    </div>
                </div>
                {/* sidebar end  */}

                {/* products  */}
                <div class="col-span-3">
                    <div class="col-span-3">
                        <div class="grid lg:grid-cols-2 xl:grid-cols-3 grid-cols-2 gap-6">
                            {content}
                        </div>

                    </div>
                </div>
            </div>
            <NewArrival></NewArrival>
        </div>
    );
};

export default Products;